import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sb-topnav navbar navbar-expand navbar-dark" }
const _hoisted_2 = {
  key: 1,
  href: "javascript:void(0)",
  class: "navbar-brand nav-logo pl-0"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "bar-line" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "bar-line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "bar-line" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_7 = { class: "navbar-nav ml-md-auto align-items-center" }
const _hoisted_8 = { class: "nav-item active" }
const _hoisted_9 = { class: "d-lg-inline d-none" }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", { class: "nav-item ml-lg-5" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "nav-link text-white",
    href: "tel:3362154530"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-phone-alt mr-1" }),
    /*#__PURE__*/_createVNode("span", { class: "d-lg-inline d-none" }, " 3362154530")
  ])
], -1)
const _hoisted_11 = {
  key: 0,
  class: "nav-item ml-lg-5"
}
const _hoisted_12 = { class: "account-button" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "Temporary Account", -1)
const _hoisted_14 = { class: "navbar-nav ml-auto profile-icon align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_16 = { class: "nav-item dropdown notifications-dropdown" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bell mr-1" }, null, -1)
const _hoisted_18 = { class: "d-sm-inline-block d-none" }
const _hoisted_19 = {
  key: 0,
  class: "notification-no"
}
const _hoisted_20 = { class: "nav-item dropdown mr-3 profile-dropdown" }
const _hoisted_21 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "userDropdown"
}
const _hoisted_22 = { class: "account-info" }
const _hoisted_23 = { class: "account-info-img" }
const _hoisted_24 = { class: "account-name" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user mr-2" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Profile")
const _hoisted_27 = {
  key: 1,
  class: "dropdown-item",
  href: "javascript:void(0)"
}
const _hoisted_28 = { class: "custom-control custom-switch mr-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "tourGuideSwitch"
}, "App Tour", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fa fa-cog mr-2" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Notification Settings")
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sign-out-alt mr-2" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Logout")
const _hoisted_34 = {
  key: 0,
  autoplay: ""
}
const _hoisted_35 = /*#__PURE__*/_createVNode("source", {
  src: "audio/pristine-609.mp3",
  type: "audio/mpeg"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Your browser does not support the audio element. ")
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "modal-wrap default-modal" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "modal fade",
    id: "exampleModal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createVNode("div", {
      class: "modal-dialog",
      role: "document"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "modal-content" }, [
        /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
          /*#__PURE__*/_createVNode("h5", {
            class: "modal-title",
            id: "exampleModalLabel"
          }, "Give Feedback"),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-body" }, "..."),
        /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-dismiss": "modal"
          }, " Close "),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn btn-primary"
          }, " Save changes ")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_InternetSpeed = _resolveComponent("InternetSpeed")
  const _component_NotificationModal = _resolveComponent("NotificationModal")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_UpdateToNormalModal = _resolveComponent("UpdateToNormalModal")
  const _component_FeedbackModal = _resolveComponent("FeedbackModal")
  const _component_MobileVerification = _resolveComponent("MobileVerification")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("nav", _hoisted_1, [
      (_ctx.state.data.userType != 'public_user')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "navbar-brand nav-logo pl-0",
            to: { name: 'admin-dashboard' }
          }, {
            default: _withCtx(() => [
              _createVNode("img", {
                class: "img-logo-big",
                src: _ctx.state.imageBaseUrl
          ? `${_ctx.state.imageBaseUrl}img/convorally-logo.png`
          : 'img/convorally-logo.png'
          ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("img", {
                class: "img-logo-small",
                src: _ctx.state.imageBaseUrl
          ? `${_ctx.state.imageBaseUrl}img/logo-favicon-white.png`
          : 'img/logo-favicon-white.png'
          ,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock("a", _hoisted_2, [
            _createVNode("img", {
              class: "img-logo-big",
              src: _ctx.state.imageBaseUrl
        ? `${_ctx.state.imageBaseUrl}img/convorally-logo.png`
        : 'img/convorally-logo.png'
        ,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("img", {
              class: "img-logo-small",
              src: _ctx.state.imageBaseUrl
          ? `${_ctx.state.imageBaseUrl}img/logo-favicon-white.png`
          : 'img/logo-favicon-white.png'
          ,
              alt: ""
            }, null, 8, ["src"])
          ])),
      _createVNode("button", {
        class: "btn btn-link btn-sm order-1 order-lg-0",
        id: "sidebarToggle",
        title: "Toogle Side Menu Bar",
        href: "javascript:void(0)",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _hoisted_6,
      _createVNode("ul", _hoisted_7, [
        _createVNode("li", _hoisted_8, [
          _createVNode("a", {
            class: "nav-link",
            href: "javascript:void(0)",
            title: "Give Feedback",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showFeedBackModal && _ctx.showFeedBackModal(...args)))
          }, [
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("having_issue")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("reach_us")), 1)
          ])
        ]),
        _hoisted_10,
        _createVNode("li", null, [
          _createVNode(_component_InternetSpeed)
        ]),
        (_ctx.state.data.isGuest != 0)
          ? (_openBlock(), _createBlock("li", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("span", {
                  class: "upgrade-text",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToSubscriptionList && _ctx.redirectToSubscriptionList(...args)))
                }, "Upgrade")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("ul", _hoisted_14, [
        (_ctx.state.userInfo.is_mobile_verified === 0 && _ctx.state.userInfo.sms_notification === 1)
          ? (_openBlock(), _createBlock("li", _hoisted_15, [
              _createVNode("a", {
                class: "nav-link verigy-tag",
                title: "Please verify Phone number to receive text notifications",
                href: "javascript:void(0)",
                "data-toggle": "modal",
                "data-target": "#verifyModal",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showMobileVerificationModal && _ctx.showMobileVerificationModal(...args)))
              }, "Verify Mobile")
            ]))
          : _createCommentVNode("", true),
        _createVNode("li", _hoisted_16, [
          _createVNode("a", {
            class: "nav-link text-white",
            href: "javascript:void(0)",
            id: "navbarDropdown",
            role: "button",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showNotificationList && _ctx.showNotificationList(...args)))
          }, [
            _hoisted_17,
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('notifications')), 1),
            (_ctx.state.data.channelActivitiesListCount)
              ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.state.data.channelActivitiesListCount), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.data.channelActivitiesList &&
            _ctx.state.data.channelActivitiesList.length
          )
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: _ctx.state.data.showNotifications
            ? 'dropdown-menu dropdown-menu-right show custom-scroll'
            : 'dropdown-menu dropdown-menu-right custom-scroll'
            ,
                "aria-labelledby": "navbarDropdown"
              }, [
                _createVNode("a", {
                  class: "dropdown-item clear-all-btn text-right",
                  href: "javascript:void(0)",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (
              _ctx.notifyAllReadNotification(_ctx.state.data.channelActivitiesList)
              ))
                }, "Clear All"),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
              .channelActivitiesList, (notification, notifyIndex) => {
                  return (_openBlock(), _createBlock("a", {
                    key: notifyIndex,
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.redirectToChannel(notification))
                  }, _toDisplayString(notification.description), 9, ["onClick"]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode("li", _hoisted_20, [
          _createVNode("a", {
            id: "userAvatarIcon",
            class: "dropdown-toggle",
            role: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.userAvatar && _ctx.userAvatar(...args)))
          }, [
            (_ctx.profileImage != 'null')
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.profileImage,
                  class: "profile-img",
                  alt: ""
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _ctx.state.imageBaseUrl
              ? `${_ctx.state.imageBaseUrl}img/no-user.jpg`
              : 'img/no-user.jpg'
              ,
                  class: "profile-img",
                  alt: ""
                }, null, 8, ["src"]))
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                (_ctx.profileImage != 'null')
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.profileImage,
                      alt: ""
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("img", {
                      key: 1,
                      src: _ctx.state.imageBaseUrl
                  ? `${_ctx.state.imageBaseUrl}img/no-user.jpg`
                  : 'img/no-user.jpg'
                  ,
                      alt: ""
                    }, null, 8, ["src"]))
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("h5", null, _toDisplayString(_ctx.state.activeUser), 1),
                _createVNode("p", null, _toDisplayString(_ctx.state.activeUserEmail), 1)
              ])
            ]),
            (_ctx.state.data.userType != 'public_user')
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.redirectToProfile && _ctx.redirectToProfile(...args)))
                }, [
                  _hoisted_25,
                  _hoisted_26
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.userType != 'public_user')
              ? (_openBlock(), _createBlock("a", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _withDirectives(_createVNode("input", {
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toogleGuideTour && _ctx.toogleGuideTour(...args))),
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "tourGuideSwitch",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.tourGuide = $event))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.state.data.tourGuide]
                    ]),
                    _hoisted_29
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.userType != 'public_user')
              ? (_openBlock(), _createBlock("a", {
                  key: 2,
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showNotificationModal && _ctx.showNotificationModal(...args)))
                }, [
                  _hoisted_30,
                  _hoisted_31
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.userType != 'public_user')
              ? (_openBlock(), _createBlock("a", {
                  key: 3,
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.logOutNav && _ctx.logOutNav(...args)))
                }, [
                  _hoisted_32,
                  _hoisted_33
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.notificationCount != 0)
      ? (_openBlock(), _createBlock("audio", _hoisted_34, [
          _hoisted_35,
          _hoisted_36
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showNotificationModal)
      ? (_openBlock(), _createBlock(_component_NotificationModal, {
          key: 1,
          showModal: _ctx.state.data.showNotificationModal,
          onClose: _ctx.closeNotificationModal
        }, null, 8, ["showModal", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _hoisted_37,
    (_ctx.state.data.showUpdateToNormalModal)
      ? (_openBlock(), _createBlock(_component_UpdateToNormalModal, {
          key: 3,
          showUpdateToNormalModal: _ctx.state.data.showUpdateToNormalModal,
          onCloseModal: _ctx.hideUpdateToNormalModal,
          onUpdatedToNoraml: _ctx.updatedToNoraml
        }, null, 8, ["showUpdateToNormalModal", "onCloseModal", "onUpdatedToNoraml"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showFeedBackModal)
      ? (_openBlock(), _createBlock(_component_FeedbackModal, {
          key: 4,
          showFeedBackModal: _ctx.state.data.showFeedBackModal,
          onCloseModal: _ctx.hideFeedBackModal
        }, null, 8, ["showFeedBackModal", "onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showMobileVerification)
      ? (_openBlock(), _createBlock(_component_MobileVerification, {
          key: 5,
          showModal: _ctx.state.data.showMobileVerification,
          onCloseModal: _ctx.hideMobileVerificationModal
        }, null, 8, ["showModal", "onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}